import React, {useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';

import DataTable from 'react-data-table-component';
// import DataTableExtensions from "react-data-table-component-extensions";
// import "react-data-table-component-extensions/dist/index.css";

import "../Pagina.css";
import "../content-styles.css"

import Swal from 'sweetalert2'

import * as Hosts from '../../../Hosts';
import {
    //set_language,
	reqGET,
	reqPOST,
	reqPUT,
    content_language,
    passwordHash,
    upgrade_cart,
    my_local_storage,
    repo_site_assets_link,
    // functionSendMail,

} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import Loader from '../../../loader'

import Navbar from "../Navbar/Navbar";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Footer from "../Footer/Footer";

import { language } from './Language';

export default function Encomendas(props) {
    const [, set_dados] = useState(null);

    const nota_de_encomenda = useRef({});
    const user_info = useRef({});
    // const encomendas = useRef(null);
    const [encomendas, set_encomendas] = useState([]);
    const [historico, set_historico] = useState([]);

	const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

    const [lang, set_lang] = useState('pt');
    const [lang_id, set_lang_id] = useState('1');
    
    useEffect(() => {

        (async () => {
            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)

            let getClientHistoric = async (id_user) => {
                // return await reqGET(`${Hosts.SIMCore_API}/estrelamaior/get/historico/rotas/${id_user}`)
                return await reqGET(`${Hosts.SIMCore_API}/estrelamaior/get/historico/rotas/${id_user}`)
                    .then(res => {

                        set_historico(res.data)

                        setLoading(false)

                    })
                    .catch(() => 404
                )
            }
            if (token_info !== undefined && token_info !== null && token_info.user_info !== undefined && token_info.user_info !== null && token_info.user_info.id !== '') {
                getClientHistoric(token_info.user_info.id)
            }
            else {
                setRedirect(true)
            }
        })()

        if(localStorage.getItem('lang') !== undefined  || localStorage.getItem('lang') !== null) {
            set_lang(localStorage.getItem('lang'))
        }

    }, [props]);

    const columns = [
        {
            name: language[lang].field_name,
            selector: 'info.rota.nome',
            sortable: true,
            left: true,
            minWidth: '100px',
            maxWidth: '70%',
        },
        {
            name: 'Percorrido',
            right: true,
            export: false,
            print: false,
            minWidth: '100px',
            maxWidth: '15%'
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            minWidth: '50px',
            maxWidth: '5%',
            cell: row => 
                <span className='d-none'>
                    <i className="bi bi-eye"></i>
                </span>
        },
    ]

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    }

    return (
        isRedirect ? 
            <Redirect to={'/'} replace />
        :
        isloading ?
            <Loader />
        :
        <>
            <Navbar /> 

            <Breadcrumb /> 

            <div id="cart" className="container-fluid my-5">
                <div className="row">
                    <div className="container">

                        <div className='row'>
                            <div className='col-12 col-lg-10'>

                                <div className="table-body">
                                        <DataTable
                                            columns={columns}
                                            data={historico}
                                            noDataComponent={language[lang].table_empty}
                                            noHeader
                                            pagination
                                            exportHeaders
                                            paginationComponentOptions={defaultComponentOptions}
                                            paginationPerPage={25}
                                            paginationRowsPerPageOptions={[25, 50, 100]}
                                        />
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            
            <Footer />
        </>

    );
}

